module.exports = __webpack_public_path__ + "img/calearna-logo-white-16x16.1c0f1177.png";